import { Checkbox } from '@/components/ui/checkbox'
import { Switch } from '@/components/ui/switch'
import { useSearchFilters } from './useSearchFilters'

export function ConditionsFilterMobile() {
  const { localFilters, updateLocalFilters } = useSearchFilters()

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <label htmlFor="pets-mobile" className="text-sm font-medium text-slate-800">
          Mazlíčci povoleni
        </label>
        <Switch
          id="pets-mobile"
          checked={localFilters.pets}
          onCheckedChange={(checked) => {
            updateLocalFilters({ pets: checked })
          }}
          className="h-7 w-12 [&_[data-slot=switch-thumb]]:size-6 [&_[data-slot=switch-thumb]]:data-[state=checked]:translate-x-5"
        />
      </div>
      <div className="flex items-center justify-between">
        <label htmlFor="adult-mobile" className="text-sm font-medium text-slate-800">
          Jen pro dospělé
        </label>
        <Switch
          id="adult-mobile"
          checked={localFilters.adult}
          onCheckedChange={(checked) => {
            updateLocalFilters({ adult: checked })
          }}
          className="h-7 w-12 [&_[data-slot=switch-thumb]]:size-6 [&_[data-slot=switch-thumb]]:data-[state=checked]:translate-x-5"
        />
      </div>
    </div>
  )
}

export function ConditionsFilterDesktop() {
  const { localFilters, updateLocalFilters } = useSearchFilters()

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Checkbox
            id="pets"
            checked={localFilters.pets}
            onCheckedChange={(checked) => {
              updateLocalFilters({ pets: !!checked }, true)
            }}
          />
          <label htmlFor="pets" className="text-sm text-slate-800">
            Mazlíčci povoleni
          </label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox
            id="adult"
            checked={localFilters.adult}
            onCheckedChange={(checked) => {
              updateLocalFilters({ adult: !!checked }, true)
            }}
          />
          <label htmlFor="adult" className="text-sm text-slate-800">
            Jen pro dospělé
          </label>
        </div>
      </div>
    </div>
  )
}
